document.addEventListener("DOMContentLoaded", async () => {
  const buttons = document.querySelectorAll(".product-template__carousel-dot");
  const images = document.querySelectorAll(".product-template__carousel-image");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const index = button.dataset.index;

      images.forEach((img) => img.classList.remove("is-active"));
      buttons.forEach((btn) => btn.classList.remove("is-active"));

      images[index].classList.add("is-active");
      button.classList.add("is-active");
    });
  });
  
  const updateMetafield = async (customerId, productId, variantId) => {
    const response = await fetch('https://api.seoulbeautyclub.com/api/customer-update-product-variant', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerId: customerId,
          productId: productId,
          productVariantId: variantId
        })
    });

    if (response.ok) {
        console.log('Metafield updated successfully');
    } else {
        console.error('Error updating metafield');
    }
  }

  const variantSelect = document.querySelector(".product-template__variant-select");
  if (variantSelect) {
    variantSelect.addEventListener("change", async (e) => {
      const selectedVariantId = e.target.value;
      const selectedVariant = e.target.options[e.target.selectedIndex];
      const productId = variantSelect.dataset.productId;
      const customerId = variantSelect.dataset.customer;

      let correctImage = false;
      images.forEach((img) => {
        if (img.dataset.alt.indexOf(selectedVariant.dataset.title) > -1) {
          console.log("correct image", img.dataset.alt, selectedVariant.dataset.title);          
          buttons[img.dataset.index].click();
        }
      });
    

      await updateMetafield(customerId, productId, selectedVariantId);
    });
  }
});
